var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurnover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#101010",
    stroke: "url(#paint0_linear_5781_3324)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4444 20.4444H21.2771C21.676 20.4444 21.9993 20.7927 21.9993 21.2222C21.9993 21.6518 21.676 22 21.2771 22H9.72218C9.32333 22 9 21.6518 9 21.2222V8.77778C9 8.34822 9.32333 8 9.72218 8C10.121 8 10.4444 8.34822 10.4444 8.77778V20.4444Z",
    fill: "#E67238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1387 17.0875C12.8659 17.4009 12.4089 17.4168 12.1179 17.123C11.8269 16.8292 11.8122 16.337 12.085 16.0236L14.7932 12.9125C15.057 12.6094 15.4954 12.5831 15.7888 12.8528L17.9263 14.8172L20.7112 11.018C20.9584 10.6809 21.4125 10.6234 21.7255 10.8895C22.0386 11.1557 22.092 11.6448 21.8449 11.9819L18.595 16.4153C18.3412 16.7616 17.871 16.8114 17.5594 16.525L15.3755 14.5179L13.1387 17.0875Z",
    fill: "#E67238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5781_3324",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnover);
export default __webpack_public_path__ + "static/media/turnover.caff29d6a6e59c8ff5e8d81159dbd2cc.svg";
export { ForwardRef as ReactComponent };